import { CheckCircleFilled } from '@ant-design/icons';
import { AntRow } from 'components/ant/AntRow';
import { Inner, ScreenContainer } from 'components/Mailer/Mailer.styled';
import { Button } from 'components/UI';
import React, { FC, ReactElement } from 'react';

interface Props {
  onCancel: () => void;
}

const Success: FC<Props> = ({ onCancel }): ReactElement => (
  <ScreenContainer>
    <Inner success>
      <AntRow justify="center">
        <CheckCircleFilled />
      </AntRow>

      <AntRow justify="center">
        <h2>Success!</h2>
      </AntRow>

      <AntRow justify="center">
        <span>Email has been sent</span>
      </AntRow>

      <AntRow justify="center">
        <Button type="primary" onClick={onCancel}>
          Close
        </Button>
      </AntRow>
    </Inner>
  </ScreenContainer>
);

export default Success;
